import { useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { IMG } from "../../data/content";

export default function AgeGate({ onConfirm }) {
  const [denied, setDenied] = useState(false);
  return (
    <motion.div
      data-testid="age-gate-modal"
      role="dialog"
      aria-modal="true"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[100] grid place-items-center overflow-hidden bg-mist px-6 text-forest-deep"
    >
      <img src={IMG("himalaya.jpg")} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25 grayscale mix-blend-multiply" />
      <div className="absolute inset-0 bg-[radial-gradient(60%_60%_at_50%_45%,rgba(255,255,255,.75),#C7E6EA_80%)]" />
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
        className="relative w-full max-w-lg text-center"
      >
        <Logo className="mx-auto h-9 sm:h-10" />
        <p className="eyebrow mt-8 text-forest">JAI <span className="font-deva">हो!</span> · Responsible drinking</p>
        <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.05] sm:text-5xl">
          Are you of legal drinking age in your country?
        </h2>
        {!denied ? (
          <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
            <button data-testid="age-gate-yes-btn" onClick={onConfirm} className="btn-gold justify-center">Yes, I am</button>
            <button data-testid="age-gate-no-btn" onClick={() => setDenied(true)} className="btn-ghost-dark justify-center">No, I'm not</button>
          </div>
        ) : (
          <p data-testid="age-gate-denied" className="mt-10 text-base text-forest-deep">
            Sorry, you need to be of legal drinking age to enter. Come back and raise a glass with us when you are. JAI <span className="font-deva">हो!</span>
          </p>
        )}
        <p className="mt-10 text-xs leading-relaxed text-forest-deep/85">
          Himachal हो! contains alcohol (&lt;5% ABV). Please enjoy responsibly. Your answer is remembered on this browser.
        </p>
      </motion.div>
    </motion.div>
  );
}
